import { printVariable } from '@util/helper'
import { useEffect, useState, useRef, useCallback } from 'react'
import consoleLogger from 'react-terminal-logger/console-logger'
import { debounce, throttle } from 'lodash'


const useDelegate = ({ initialValues, onSubmit, validate }) => {

  const [values, set_values] = useState({ ...initialValues })
  const [errors, _set_errors] = useState({})
  const [canSubmit, set_canSubmit] = useState(false)

  const errorsRef = useRef(errors)
  const valuesRef = useRef(values)

  const set_errors = (errs) => {
    errorsRef.current = errs
    _set_errors(errs)
  }

  const handleChange = async (data, callback) => {

    if (data && (data.target || (data.name !== undefined && data.value !== undefined && data.name !== null && data.name.trim() !== ''))) {
      const name = data.target ? data.target.name : data.name
      const value = data.target ? data.target.value : data.value

      valuesRef.current[name] = value
      values[name] = value

      if (callback) {
        callback()
      }

      const oldError = errorsRef.current[name]
      const newError = await validate(name, value)

      if (oldError != newError) {
        const newErrors = { ...errorsRef.current }
        if (newError) {
          newErrors[name] = newError
        }
        else {
          delete newErrors[name]
        }
        errorsRef.current = newErrors
        set_errors(newErrors)
      }
    }
    else {
      if (callback) {
        callback()
      }

      const entries = [...Object.entries(errorsRef.current), ...Object.entries(valuesRef.current)]
      for (const [name, value] of entries) {
        const err = await validate(name, value)
        // console.log(`${name} =>`, err)
        if (err) {
          errorsRef.current[name] = err
        }
        else {
          delete errorsRef.current[name]
        }
      }
      set_errors({ ...errorsRef.current })
    }

    return errorsRef.current
  }


  const updateState = (data) => {
    let nextValues = { ...valuesRef.current }

    if(data) {
      if (data.target) {
        const { name, value } = data.target
        nextValues[name] = value
      }
      else if (typeof data === 'object') {
        const keys = Object.keys(data)
        // name과 value만 가진 특수한 단일 필드 업데이트용 객체인지 확인
        const isSingleField = keys.length === 2 && keys.includes('name') && keys.includes('value')
  
        if (isSingleField && typeof data.name === 'string' && data.name.trim() !== '') {
          // 단일 필드 업데이트 처리
          nextValues[data.name] = data.value
        } 
        else {
          // user 객체 등 일반적인 모델 객체는 전체 병합 처리
          Object.assign(nextValues, data)
        }
      }

  
      // // else if (data.name !== undefined && data.value !== undefined && data.name !== null && data.value !== null && data.name.trim() !== '') {
      // else if (data.name !== undefined && data.name !== null && data.name.trim() !== '') {
      //   nextValues[data.name] = data.value
      // }
  
      // else if (typeof data === 'object') {
      //   Object.assign(nextValues, data)
      // }
    }
    

    // 깊은 복사 수행 (리액트 상태 감지 및 불변성 유지)
    const newValues = JSON.parse(JSON.stringify(nextValues))


    Object.assign(valuesRef.current, newValues)

    set_values(newValues)

  }

  const handleSubmit = async (event) => {

    // 모든 데이터의 상태 값 현행화, useEffect 에서 반영되므로, useEffect 에서 submit 처리
    set_canSubmit(false)
    updateState()
    //


    event?.preventDefault()
    const newErrors = { ...errorsRef.current }

    // 필드 입력 값 체크
    for (const [name, value] of Object.entries(valuesRef.current)) {
      const err = await validate(name, value)
      newErrors[name] = err
    }

    let errCount = 0

    // 필드 입력 만으로는 알 수 없는 에러 체크 
    errCount = Object.values(newErrors).filter(r => r).length
    // TODO
    // if(errCount === 0) {
    const error = await validate('error', '')
    newErrors.error = error

    set_errors(newErrors)

    // 에러 없으면 canSubmit 
    errCount = 0

    for (const [name, value] of Object.entries(newErrors)) {
      if (value) {
        errCount = errCount + 1
      }
    }
    console.log('errCount=>', errCount)
    if (errCount === 0) {
      set_canSubmit(true)
    }
  }

  useEffect(() => {
    if (canSubmit && onSubmit) {
      onSubmit()
      set_canSubmit(false)
    }
  }, [canSubmit])


  // useEffect(() => {
  //   if (!shallowEqual(initialValues, values)) {
  //     set_values(initialValues);
  //   }
  // }, [initialValues]);

  return { activeRow: values, errors: errors, updateState, handleChange, handleSubmit, factor: valuesRef.current }
}

export default useDelegate
